import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "../Global/Loader/Index";
import AlertMessage from "../../components/Global/Message/Alert";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px",
        maxWidth: "230px",
        backgroundColor: "#950000",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#950000",
            boxShadow: "none",
        },
        color: "#fff",
        width: "100%",
    },
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    cursor: {
        cursor: "pointer",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
}));

const ManageComments = () => {
    const classes = useStyles();
    const [pageLoading, setPageLoading] = React.useState(true);
    // productList,newProduct,managingCategory
    const [commentsList, setCommentsList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [id, setId] = useState(0);
    const [tab, setTab] = useState(1);

    const handleClickOpen = (id) => {
        setOpen(true);
        setId(id || "");
    };

    const handleClose = () => {
        setOpen(false);
        setId("");
    };

    const getFactors = async (item = 1) => {
        setPageLoading(true)
        setCommentsList([]);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            let url = ''
            if (item === 1)
                url = `/api/admin/products/commentslist/?pageId=${currentPage}`
            else if (item === 2)
                url = `/api/admin/articles/commentslist/?pageId=${currentPage}`

            const { data } = await axios.get(url,
                config
            );
            if (data.status === "ok") {
                setCommentsList(data.data.comments);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    useEffect(() => {
        getFactors(1);
    }, []);

    const activer = (tab) => {
        setTab(tab);
        getFactors(tab)
    };

    return (
        <>
            <Box className={classes.grayerBox} mt={2} borderRadius={10}>
                <Button
                    className={tab === 1 ? classes.btnActive : classes.btn}
                    variant="contained"
                    onClick={() => activer(1)}>نظرات محصولات</Button>
                <Button
                    className={tab === 2 ? classes.btnActive : classes.btn}
                    variant="contained"
                    onClick={() => activer(2)}>نظرات مقالات</Button>
            </Box>
            <Box borderRadius={10} mt={0} mr={2} pb={1} className={classes.grayBox}>
                <Box px={2} mt={1}>
                    <Box
                        bgcolor="#950000"
                        borderRadius={10}
                        color="#fff"
                        p={2}
                        textAlign="center">
                        <Grid container>
                            <Grid xs={3}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">مشخصات کاربر</Box>
                            </Grid>
                            <Grid xs={5}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">نظر</Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">تاریخ</Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">عملیات</Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {(pageLoading) ? (
                        <Box mt={3}>
                            <Loader text="در حال بارگزاری..." />
                        </Box>
                    ) : (
                        (commentsList.length) > 0 ? (
                            commentsList.map((item, i) => (
                                <Box
                                    style={{ padding: "25px 15px 25px 15px" }}
                                    bgcolor="#fff"
                                    borderRadius={10}
                                    boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                    mt={2}
                                    textAlign="center">
                                    <Grid container>
                                        <Grid xs={3}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.user.fullName}
                                            </Box>
                                        </Grid>
                                        <Grid xs={5}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.text}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.date}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                fontWeight="bold"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%"
                                                color="#459BFF"
                                                style={{ textDecoration: "underline", cursor: "pointer" }}>
                                                {(tab === 1) ? (
                                                    <Link to={`/product/${item.productId}/#c${item.id}`}>
                                                        نمایش نظر
                                                    </Link>
                                                ) : (
                                                    <Link to={`/article/${item.articleId}/#c${item.id}`}>
                                                        نمایش نظر
                                                    </Link>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))
                        ) : (
                            <>
                                <Box mt={3} mb={1}>
                                    <AlertMessage variant="info">
                                        موردی جهت نمایش وجود ندارد.
                                    </AlertMessage>
                                </Box>
                            </>
                        )
                    )}
                </Box>

            </Box>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    ویرایش وضعیت فاکتور
        </DialogTitle>
                <DialogContent style={{ minWidth: "400px" }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">
                                وضعیت
              </InputLabel>
                            <Select
                                fullWidth
                                name="category"
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                label="  وضعیت"
                            >
                                <MenuItem disabled value="">
                                    <em> انتخاب کنید</em>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        width="100%"
                    >
                        <Button
                            variant="contained"
                            onClick={handleClose}
                            className={classes.btnRed}
                        >
                            انصراف
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button color="secondary" variant="contained">
                            {/* {deleteLoading ? (
                <CircularProgress size={25} color="inherit" />
              ) : ( */}
                            <>اعمال تغییرات</>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ManageComments;
